/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

// Función global para cargar GTM dinámicamente cuando hay consentimiento
declare global {
  interface Window {
    loadGTM?: () => void
    gtmLoaded?: boolean
  }
}

const GtagWrapper = () => {
  const [gtmConsent, setGtmConsent] = useState(false)

  useEffect(() => {
    // Definir función global para cargar GTM
    window.loadGTM = () => {
      if (window.gtmLoaded) return // Evitar carga duplicada

      console.log('%c%s', 'color: green;', 'GTM LOAD - Consent granted')

      // Cargar GTM script
      const script = document.createElement('script')
      script.innerHTML = `(function(w,d,s,l,i){w[l] = w[l] || [];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${GTM_ID}');`
      document.head.appendChild(script)

      // Cargar GTM noscript iframe
      const iframe = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}"
        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>`
      const noscript = document.createElement('noscript')
      noscript.innerHTML = iframe
      document.body.insertBefore(noscript, document.body.childNodes[0])

      window.gtmLoaded = true
      setGtmConsent(true)
    }

    return () => {
      delete window.loadGTM
    }
  }, [])

  return (
    <Helmet>
      {/* Inicializar dataLayer y gtag ANTES de GTM (siempre disponible) */}
      <script>{`window.dataLayer = window.dataLayer || []; function gtag() {window.dataLayer.push(arguments); }`}</script>

      {/* Solo cargar gtag config si GTM ya fue cargado */}
      {gtmConsent && <script>{`gtag('js', new Date()); gtag('config', '${GTM_ID}');`}</script>}

      {API_KEY_MAPS && <script src={`https://maps.googleapis.com/maps/api/js?key=${API_KEY_MAPS}`}></script>}
    </Helmet>
  )
}

export default GtagWrapper
